import { MCD } from '@/services/app';
import AvatarOptions from './AvatarOptions';
import { useRef, useState, useEffect } from 'react';
import type { IAvatarOptionsPanelPops } from './types';
import AvatarOptionsButtons from '@/components/AvatarOptionsButtons';
import AvatarOptionsPanelContainer from './AvatartOptionsPanel.styles';

type AppVersion = {
  platform: string;
  version: string;
  build: string;
};

const AvatarOptionsPanel: React.FC<IAvatarOptionsPanelPops> = ({
  disabledBack,
  onBackClick,
  onSaveClick,
  onNextClick,
  scrollRight,
  onTabClick,
  setOptions,
  activeTab,
  options
}) => {
  const [visibleButtons, setVisibleButtons] = useState(true);
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const save = () => ~onSaveClick() && setSaving(true);

  const newVersion = useRef(false);

  const toggleButtons = (visible: boolean) => {
    setVisibleButtons(visible);
  };

  useEffect(() => {
    MCD.getAppVersion().then((data) => {
      const { version } = data as AppVersion;
      newVersion.current = version.startsWith('3.0');
    });
  }, []);

  return (
    <AvatarOptionsPanelContainer
      isFocus={isFocus && !newVersion.current}
      buttons={visibleButtons}
    >
      <AvatarOptions
        toggleButtons={toggleButtons}
        scrollRight={scrollRight}
        onTabClick={onTabClick}
        setOptions={setOptions}
        setIsFocus={setIsFocus}
        activeTab={activeTab}
        options={options}
      />

      {visibleButtons && (
        <AvatarOptionsButtons
          disabledSave={!options.name || saving}
          disabledNext={!options.name}
          disabledBack={disabledBack}
          onNextClick={onNextClick}
          onBackClick={onBackClick}
          onSaveClick={save}
        />
      )}
    </AvatarOptionsPanelContainer>
  );
};

export default AvatarOptionsPanel;
